import React from "react";
import { useQuery } from "react-query";
import { getOauthHandleForNamePurchase } from "./gateway";

export default function useOauthHandleForNamePurchase(
  mode: string,
  token: string,
  oauthVerifier: string,
) {
  return useQuery({
    queryFn: () => getOauthHandleForNamePurchase(mode, token, oauthVerifier),
    queryKey: "handle-ggsis-login",
    retry: false,
  });
}
